import { useState, useEffect } from "react";

export const useActiveTab = (items, defaultValue = null) => {
  const [activeTab, setActiveTab] = useState(defaultValue);
  
  useEffect(() => {
    if (items && items.length > 0) {
      setActiveTab((prev) => prev ?? (items[0].id || 0));
    }
  }, [items]);
  
  return [activeTab, setActiveTab];
};

